import styled from 'styled-components';
import Modal from 'components/Core/Modal';

export const StyledModal = styled(Modal)`
  .tools-roi-section--container {
    padding: 0;
  }
`;
